import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from '@env';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { HttpError, ValidationError } from '@shared/models';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    constructor(
        private toastController: ToastController,
        private translate: TranslateService
    ) { }
    
    async handleError(error: Error) {
        
        // if (!environment.production) {
            console.error(error);
        // }

        let message = this.translate.instant('messages.unknown_error');
        if ((!environment.production && error.message) || error instanceof ValidationError || error instanceof HttpError) {
            message = error.message;
        }
        
        if (message) {
            const toast = await this.toastController.create({
                message: message,
                duration: 4000,
                position: 'top',
                color: 'danger'
            });
            toast.present();
        }
    }

}